import React from "react";
import LineGraph from "./lineGraph";

// import LineGraphTSV from "./lineGraphTSV";

import FrequencyGraphStyle from "./frequencyGraph.module.css";
import { getGraphTitle, getTooltipName } from "../../service/textRetrieval";

const FrequencyGraph = ({ textLiterals, variant = "ukvui" }) => {
  const [tooltipName, setTooltipName] = React.useState("");
  const [title, setTitle] = React.useState("");
  const avgValue = "expSmoothingPerc";
  const avgValues = {
    percOfUKVUI: `Percent of ${tooltipName} (Average over past 1 week)`,
    percOfUKVUI_2wkavg: `Percent of ${tooltipName} (Average over past 2 week)`,
    percOfUKVUI_3wkavg: `Percent of ${tooltipName} (Average over past 3 week)`,
    percOfUKVUI_4wkavg: `Percent of ${tooltipName} (Average over past 4 week)`,
    expSmoothingPerc: `Exponential Smoothing of Weekly ${tooltipName} percentages`,
  };
  React.useEffect(() => {
    setTitle(getGraphTitle(textLiterals));
    setTooltipName(getTooltipName(variant, textLiterals));
  }, [variant, textLiterals]);
  return (
    <div>
      <h2 className={FrequencyGraphStyle.title}>
        {title ?? "Relative Frequency per Region"}
      </h2>
      <div className={FrequencyGraphStyle.subtitle}>
        Click Legend to show/hide series
      </div>

      <LineGraph
        variant={variant}
        tooltipName={tooltipName}
        avgValueKey={avgValue}
        avgValueLabel={avgValues[avgValue]}
        textLiterals={textLiterals}
      />
      {/* <LineGraphTSV avgValues={avgValues} avgAmount={avgAmount} /> */}
    </div>
  );
};

export default FrequencyGraph;
